import { Injectable } from '@angular/core';
import { Logger, LoggerOptions, LoggerOptionsService } from './logger';

/* eslint-disable no-console */
@Injectable()
export class ConsoleLogger implements Logger {
  constructor(private _optionsManager: LoggerOptionsService) {}

  public error(
    error: Error | string,
    properties?: { [name: string]: string },
    options?: LoggerOptions,
  ) {
    if (properties != null) {
      console.error(error, properties);
    } else {
      console.error(error);
    }
  }
  public info(message: string, properties?: { [name: string]: string }, options?: LoggerOptions) {
    if (this._optionsManager.canLogToConsole(options)) {
      if (properties != null) {
        console.info(message, properties);
      } else {
        console.info(message);
      }
    }
  }
  public warning(
    message: string,
    properties?: { [name: string]: string },
    options?: LoggerOptions,
  ) {
    /* eslint-disable-next-line */
    if (properties != null) {
      console.warn(message, properties);
    } else {
      console.warn(message);
    }
  }
}
